/* ASYCO 2 AI - Filtros en vivo en colecciones (sin recargar la pagina):
   1) Mantiene sincronizadas nuestras secciones server-rendered (chips de filtro activo
      `asyco_active_filters` y tira "Filtra por marca" `asyco_brand_filter`) en cada cambio
      de filtro, via Section Rendering API. El tema Horizon filtra por AJAX y dispara
      'filter:update', pero NO re-renderiza estas secciones -> sin esto quedaban obsoletas
      (los chips solo aparecian al recargar).
   2) Hace que un clic en una pildora de marca aplique el filtro por marca AJAX del tema
      (marca el checkbox de vendor correspondiente) en vez de recargar.
   Cargado una sola vez desde theme.liquid (listeners unicos). Solo actua donde existen las
   secciones (paginas de coleccion). */
(function () {
  'use strict';

  var SECTION_MATCHES = ['__asyco_active_filters', '__asyco_brand_filter'];

  function sectionEls() {
    var out = [];
    for (var i = 0; i < SECTION_MATCHES.length; i++) {
      var el = document.querySelector('[id^="shopify-section-"][id*="' + SECTION_MATCHES[i] + '"]');
      if (el) out.push(el);
    }
    return out;
  }

  var busy = false, again = false;

  function refresh() {
    var els = sectionEls();
    if (!els.length) return;                 // no estamos en una coleccion con estas secciones
    if (busy) { again = true; return; }
    busy = true;
    Promise.all(els.map(function (el) {
      var id = el.id.replace(/^shopify-section-/, '');
      var u = new URL(window.location.href);
      u.searchParams.set('section_id', id);
      return fetch(u.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (html == null) return;
          var fresh = new DOMParser().parseFromString(html, 'text/html')
            .getElementById('shopify-section-' + id);
          el.innerHTML = fresh ? fresh.innerHTML : html;   // la respuesta trae el wrapper -> su interior
        })
        .catch(function () {});
    })).then(function () {
      busy = false;
      if (again) { again = false; refresh(); }
    });
  }

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(refresh, 120); }

  document.addEventListener('filter:update', schedule);
  window.addEventListener('popstate', schedule);

  // Pildora de marca -> aplica el filtro por marca AJAX del tema (marca el checkbox de vendor).
  // Si no hay checkbox (o ya esta marcado), deja que el enlace navegue normal (fallback).
  document.addEventListener('click', function (e) {
    var pill = e.target.closest && e.target.closest('.asyco-brandf__pill[data-vendor]');
    if (!pill) return;
    var vendor = pill.getAttribute('data-vendor');
    var input = null;
    var inputs = document.querySelectorAll('input[name="filter.p.vendor"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === vendor) { input = inputs[i]; break; }
    }
    if (input && !input.checked) {
      e.preventDefault();
      input.checked = true;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
})();
